import { api } from '@/main'

const session = {
  namespaced: true,  
  state: () => ({
    values: null,
  }),
  mutations: {
    load(state) {
      let rawSession = localStorage.getItem('session')
      if (!rawSession) return
      let sess = JSON.parse(rawSession)
      if (!sess.token) return
      state.values = sess
      api.setToken(sess.token)
    },
    set(state, newSession) {
      state.values = newSession
      api.setToken(newSession.token)
      localStorage.setItem('session',JSON.stringify(newSession))
    },
    clear(state) {
      state.values = null
      api.setToken(null)
      localStorage.removeItem('session')
    }
  },
  actions: {
    async auth({ commit, state }, params) {
      if (!!state.values) {
        api.logout().then().catch(e => {})
        commit('clear')
      }
      await api.login(params.login, params.password)
      commit('set',{ token: api.token })
    },
    async logout({ commit, state }) {
      if (!!state.values) {
        api.logout().then().catch(e => {})
        commit('clear')
      }
    }
  }
}

export default session